<template>
    <div class="popup__wrap">
        <div class="popup__title popup__title--mb">
            {{ $t("translation.downloading") }}...
        </div>
        <div class="popup__message mb-2">
            {{ description }}
        </div>
        <div class="popup__progress-bar">
            <div class="popup__progress-bar_progress" :style="{ width: `${percent}%` }">
                <div class="line-progress"></div>
                <div class="line-progress--intersection"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            description: {
                default: '',
            },
            percent: {
                type: Number,
                default: 0,
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/pop-up/Download.vue